export default __webpack_public_path__ + "304e327744ae5c9b1b62b58f50df6734.svg";